<div class="spo-detail-section-detail">
  @if (isEdit) {
    <div class="section-heading">Detail</div>
  }
  <div class="spo-detail-content">
    <div class="grid-item spo-detail-partner">
      <app-input-dropdown #partnerInput
        (inputStateChange)="managePartnerInputStateChange($event)"
        (inputValueChange)="setPartnerValue($event)"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [labelInformation]="partnerInformation"
        [messages]="partnerInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchPartners"
        [validators]="validators.partner"
        [warningLevel]="WarningsEnum.WARNING"
        baseCypressTag="spo-header-form-partner"
        label="Partner"
      placeholder="Select partner"></app-input-dropdown>

      <ng-template #partnerInformation>
        <app-tooltip [message]="partnerInfoLabel" [orderedList]="false"
          [tooltipType]="TooltipEnum.INFORMATION"
          class="display-inline-flex vertical-align-baseline"
        placement="right"></app-tooltip>
      </ng-template>
    </div>

    <div class="grid-item spo-detail-supplying-packing-plant">
      <app-input-dropdown #supplyingPackingPlantInput
        (inputStateChange)="manageSupplyingPackingPlantInputStateChange($event)"
        (inputValueChange)="setSupplyingPackingPlant($event)"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="supplyingPackingPlantInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchSupplyingPackingPlant"
        [validators]="validators.supplyingPackingPlant"
        [warningLevel]="WarningsEnum.WARNING"
        baseCypressTag="spo-header-form-supplying-packing-plant"
        label="Supplying packing plant"
      placeholder="Search or select supplying packing plant"></app-input-dropdown>
    </div>

    <div class="grid-item spo-detail-transport-mode">
      <app-input-dropdown #transportModeInput
        (inputStateChange)="manageTransportModeInputStateChange($event)"
        (inputValueChange)="setTransportMode($event)"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="transportModeInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchTransportMode"
        [validators]="validators.transportMode"
        baseCypressTag="spo-header-form-transport-mode"
        label="Transport mode"
      placeholder="Search or select transport mode"></app-input-dropdown>
    </div>

    <div class="grid-item spo-detail-ship-to-party">
      <app-input-dropdown #shipToPartyInput
        (inputStateChange)="manageShipToPartyInputStateChange($event)"
        (inputValueChange)="setShipToPartyValue($event)"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="shipToPartyInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchShipToParty"
        [validators]="validators.shipToParty"
        [warningLevel]="WarningsEnum.WARNING"
        baseCypressTag="spo-header-form-ship-to-party"
        label="Ship to party"
      placeholder="Select ship to party"></app-input-dropdown>
    </div>

    <div class="grid-item spo-detail-reason">
      <app-input-dropdown #reasonInput
        (inputStateChange)="manageReasonInputStateChange($event)"
        (inputValueChange)="setReason($event)"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="reasonInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchReason"
        [validators]="validators.reason"
        baseCypressTag="spo-header-form-reason"
        label="Reason"
      placeholder="Search or select reason"></app-input-dropdown>
    </div>

    <div class="grid-item spo-detail-transport-service">
      <app-input-dropdown #transportServiceInput
        (inputStateChange)="manageTransportServiceInputStateChange($event)"
        (inputValueChange)="setTransportService($event)"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="transportServiceInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchTransportService"
        [validators]="validators.transportService"
        baseCypressTag="spo-header-form-transport-service"
        label="Transport service"
      placeholder="Search or select transport service"></app-input-dropdown>
    </div>

    <div class="grid-item spo-detail-justification">
      <app-input-textarea #justificationInput
        (inputStateChange)="manageJustificationInputStateChange($event)"
        (inputValueChange)="setJustification($event)"
        [height]="118"
        [maxLength]="256"
        [messages]="justificationInputMessages"
        [validators]="validators.justification"
        baseCypressTag="spo-header-form-justification"
        label="Justification"
        placeholder="Please, justify your option here">
      </app-input-textarea>
    </div>

    <div #gridItem class="grid-item spo-detail-requested-date">

      <app-input-date #requestedDateInput
        (inputStateChange)="manageRequestedDateInputStateChange($event)"
        (inputValueChange)="setRequestedDate($event)"
        [displayMonths]="displayMonths"
        [messages]="requestedDateInputMessages"
        [minDate]="minDate"
        [validators]="validators.requestedDate"
        baseCypressTag="spo-header-form-requested-date"
        label="Requested date"
        placeholder="dd-mm-yyyy">
      </app-input-date>
    </div>
  </div>
</div>
